var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 24,
    viewBox: "0 0 155 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.2526 0H71.4951V23.537H79.2526V0Z",
    fill: "#03071E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7993 6.68356H0V0.0632935H21.3196V6.68356H14.5202V23.4733H6.79676V6.68356H6.7993Z",
    fill: "#03071E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.068 0.0632935H34.3559C38.4493 0.0632935 41.0565 1.09904 42.6722 2.739C43.3867 3.46423 43.9437 4.33283 44.3074 5.28904C44.6712 6.24526 44.8337 7.26799 44.7844 8.29159V8.35718C44.8211 9.87552 44.4064 11.37 43.5941 12.6463C42.7818 13.9227 41.6095 14.922 40.2294 15.5144L45.6089 23.4742H36.7961L32.4396 16.7849H30.7889V23.4742H23.0654V0.0632935H23.068ZM34.1251 11.1978C35.9742 11.1978 37.0968 10.3623 37.0968 8.92341V8.85521C37.0968 7.35076 35.9427 6.61107 34.16 6.61107H30.794V11.1943L34.1251 11.1978Z",
    fill: "#03071E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4756 12.9739V0.0630062H54.3302V12.8703C54.3302 15.7808 55.8147 17.0133 57.8947 17.0133C59.9746 17.0133 61.4591 15.8766 61.4591 13.0334V0.0604248H69.3104V12.8021C69.3104 20.7948 64.7229 23.9366 57.824 23.9366C50.925 23.9366 46.4756 20.7292 46.4756 12.9739Z",
    fill: "#03071E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.243 0.0632935H129.946V6.48332H117.832V8.85782H129.12V14.5105H117.832V17.0542H130.11V23.4742H110.243V0.0632935Z",
    fill: "#03071E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M132.194 0.0632935H143.482C147.575 0.0632935 150.182 1.09904 151.798 2.739C152.513 3.46423 153.07 4.33283 153.434 5.28904C153.797 6.24526 153.96 7.26799 153.91 8.29159V8.35718C153.947 9.87552 153.532 11.37 152.72 12.6463C151.908 13.9227 150.736 14.922 149.356 15.5144L154.735 23.4742H145.922L141.566 16.7849H139.915V23.4742H132.192L132.194 0.0632935ZM143.251 11.1978C145.1 11.1978 146.223 10.3623 146.223 8.92341V8.85521C146.223 7.35076 145.066 6.61107 143.286 6.61107H139.92V11.1943L143.251 11.1978Z",
    fill: "#03071E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9453 10.6235L85.7625 0H94.8461L86.8033 10.2567L94.8461 23.5369H85.5368L77.9453 10.6235Z",
    fill: "#E73B19"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7197 10.6235L100.537 0H109.621L101.578 10.2567L109.621 23.5369H100.309L92.7197 10.6235Z",
    fill: "#F99E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fff53c82d75ded4d23f083ef4049aef2.svg";
export { ForwardRef as ReactComponent };